import { render, staticRenderFns } from "./AttachmentsForm.vue?vue&type=template&id=27e00f9e&scoped=true&"
import script from "./AttachmentsForm.vue?vue&type=script&lang=ts&"
export * from "./AttachmentsForm.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentsForm.vue?vue&type=style&index=0&id=27e00f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e00f9e",
  null
  
)

export default component.exports